// extracted by mini-css-extract-plugin
export var checkbox = "_3y-0";
export var circle = "_3y-3";
export var horizontalContainer = "_3y-7";
export var sm = "_3y-5";
export var switch0 = "_3y-2";
export var switchDisabled = "_3y-8";
export var switchEnabled = "_3y-1";
export var textSwitchContainer = "_3y-9";
export var textSwitchOption = "_3y-a";
export var textSwitchOptionSelected = "_3y-b";
export var verticalContainer = "_3y-6";
export var xs = "_3y-4";